import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import QuickLink from "../../components/QuickLink";

function QuickLinksPage() {
  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:flex md:flex-row">
        <QuickLink />
      </div>
    </div>
  );
}

export default QuickLinksPage;
